import { render, staticRenderFns } from "./ContextmenuItem.vue?vue&type=template&id=69b43a93&"
import script from "./ContextmenuItem.vue?vue&type=script&lang=js&"
export * from "./ContextmenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports